import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { OnsiteCampaignResponse } from 'sections/onsite-campaigns/types';

export const useCampaignQuery = (siteId: string, campaignId: string) => {
  const campaignQuery = useQuery(
    ['onsite-campaign', siteId, campaignId],
    async () => {
      const result = await RestApi.get<OnsiteCampaignResponse>(
        `/sites/${siteId}/onsite/campaigns/${campaignId}?email=true`,
      );
      return result.data;
    },
    { enabled: campaignId !== 'new' },
  );

  return campaignQuery;
};
